import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";
import styles from "./m3.module.css";

/**
 * Toolbar, one line: leading content (e.g. a title or tabs), search and filters, then actions on the right.
 * Wraps onto extra lines only when the screen is too narrow.
 *
 * @param {React.ReactNode} leading - shown before the search field
 * @param {string} search - controlled search value
 * @param {function} onSearchChange - receives the new string; omit to hide the search field
 * @param {React.ReactNode} filters - chips/selects shown after the search field
 * @param {React.ReactNode} actions - buttons aligned to the right
 */
const M3Toolbar = ({ leading, search, onSearchChange, searchPlaceholder, filters, actions, className = "" }) => {
  const { t } = useTranslation();
  const placeholder = searchPlaceholder || t("Search");
  const hasCenter = Boolean(onSearchChange || filters);
  return (
    <div className={`${styles.toolbar} ${className}`} role="toolbar">
      {leading && <div className={styles.toolbarLeading}>{leading}</div>}
      {hasCenter && (
        <div className={styles.toolbarLead}>
          {onSearchChange && (
            <label className={styles.search}>
              <SearchIcon fontSize="small" aria-hidden />
              <input
                className={styles.searchInput}
                value={search ?? ""}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder={placeholder}
                aria-label={placeholder}
              />
              {search && (
                <button type="button" className={styles.searchClear} onClick={() => onSearchChange("")} aria-label={t("Clear search")}>
                  <CloseIcon fontSize="small" />
                </button>
              )}
            </label>
          )}
          {filters}
        </div>
      )}
      {actions && <div className={styles.toolbarTrail}>{actions}</div>}
    </div>
  );
};

export default M3Toolbar;
